import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { AlertComponent } from 'src/app/core/components/alert/alert.component';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MawbService } from 'src/app/shared/services/mawb.service';
import { ShipmentService } from 'src/app/shared/services/shipment.service';
import { palletListConvertor } from './palletListConvertor';
import { PalletDetailsComponent } from '../pallet-details/pallet-details.component';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';

interface tableData {
  select: any;
  PalletID: number;
}

@Component({
  selector: 'app-pallet-creation',
  templateUrl: './pallet-creation.component.html',
  styleUrls: ['./pallet-creation.component.scss'],
})
export class PalletCreationComponent implements OnInit {
  mawId;
  palletsData;
  ctrycode;
  ctryServiceCode;
  isMawOpened = false;
  filterOpenPallet: any;
  palletList = [];
  packageTypes;
  additionalCharges = [];
  invoiceReference = [];
  hasChargesConfig: boolean = false;
  mawbInvoiceReference: string = '';
  mawbInvoiceNumber: string = '';
  dataSource = new MatTableDataSource<tableData>();
  displayedColumns: string[] = [
    'palletID',
    'totalLinkedPieces',
    'packagingType',
    'length',
    'width',
    'height',
    'weight',
    'closed',
    'Action',
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private mawService: MawbService,
    private shipmentService: ShipmentService,
    private configService: ConfigService,
    private errorDialogService: ErrorDialogService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      mawbId: string;
      motherStatus: string;
      additionalCharges: any;
      invoiceReference: any;
      mawbInvoiceReference: string;
      mawbInvoiceNumber: string;
    }
  ) {}

  ngOnInit() {
    this.mawId = this.data?.mawbId;
    this.mawbInvoiceReference = this.data?.mawbInvoiceReference;
    this.mawbInvoiceNumber = this.data?.mawbInvoiceNumber;
    this.isMawOpened = this.data?.motherStatus === 'Open';
    this.getPallets();
    this.getPackageTypes();
    this.additionalCharges = this.data?.additionalCharges;
    this.invoiceReference = this.data?.invoiceReference;
    this.loadChargeConfig();
  }

  loadChargeConfig() {
    this.configService.fetchConfig('additional_charges').then(res => {
      if (res.data) {
        this.hasChargesConfig = (res.data || []).length > 0;
      }
    });
  }

  getPackageTypes() {
    this.configService.fetchConfig('packaging_types').then(res => {
      if (res.data) {
        this.packageTypes = res.data;
      }
    });
  }

  NavToPalletDetail(element) {
    const dialogRef = this.dialog.open(PalletDetailsComponent, {
      autoFocus: false,
      maxHeight: '90vh',
      maxWidth: '100vw',
      data: {
        mawbId: this.mawId,
        palletId: element.palletID,
        palletStatus: element.closed,
        countryCode: this.ctrycode,
        countryServiceCode: this.ctryServiceCode,
        motherStatus: this.data?.motherStatus,
        mawbInvoiceReference: this.mawbInvoiceReference,
        mawbInvoiceNumber: this.mawbInvoiceNumber,
      },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.getPallets();
    });
  }

  createPallet() {
    if (!this.isPalletOpen()) {
      this.createNewPallet('CREATE');
    } else {
      const dailogData = {
        message: 'alert.existingPallet',
      };
      const alertDialog = this.dialog.open(AlertComponent, {
        data: dailogData,
      });
      alertDialog.afterClosed().subscribe(res => {
        if (res == 'true') {
          this.managePallet('CLOSE', this.filterOpenPallet[0].palletID);
          this.createNewPallet('CREATE');
        } else {
          this.dialog.closeAll();
        }
      });
    }
  }

  isPalletOpen() {
    this.filterOpenPallet = [];
    if (!this.palletsData.closed) {
      this.filterOpenPallet = this.palletList.filter(x => x.closed == false);
      if (this.filterOpenPallet.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  }

  managePallet(status, id) {
    const reqData: any = {};
    reqData.palletID = id;
    reqData.operation_type = status;
    reqData.mawb = this.mawId;
    this.mawService.managePallet(reqData).subscribe(() => {
      this.getPallets();
    });
  }

  closeDisabled(palletID) {
    const data = this.palletList.find(item => item.palletID === palletID);
    return (
      this.checkValidation(data.weight) &&
      this.checkValidation(data.dimensions.length) &&
      this.checkValidation(data.dimensions.width) &&
      this.checkValidation(data.dimensions.height)
    );
  }

  checkValidation(input) {
    //const pattern = /^[0-9]+(.[0-9]{0,1})?$/;
    const pattern: RegExp = /^(?=.*[1-9])\d*(?:\.\d{0,3})?$/;
    return pattern.test(input);
  }

  closurePallet(palletData) {
    if (palletData?.totalLinkedPieces === 0) {
      return this.errorDialogService.openDialog(
        'At least one Baby Piece ID should be linked before closing the Mother Pallet.',
        false
      );
    }

    if (this.closeDisabled(palletData.palletID)) {
      const requestBody = {
        operation_type: 'CLOSE',
        mawb: this.mawId,
        palletID: palletData.palletID,
        packageType: palletData?.packageTypes?.packagingType,
        weight: Number(palletData.weight),
        dimensions: {
          length: Number(palletData?.dimensions.length),
          width: Number(palletData?.dimensions.width),
          height: Number(palletData?.dimensions.height),
        },
      };

      this.mawService.managePallet(requestBody).subscribe(() => this.getPallets());
    }
  }

  createNewPallet(status) {
    const reqData: any = {};
    reqData.operation_type = status;
    reqData.mawb = this.mawId;
    this.mawService.managePallet(reqData).subscribe(() => {
      this.getPallets();
    });
  }

  deletePallet(status, id) {
    const dailogData = {
      message: 'alert.piecesDelink',
    };
    const alertDialog = this.dialog.open(AlertComponent, {
      data: dailogData,
    });
    alertDialog.afterClosed().subscribe(res => {
      if (res == 'true') {
        this.delinkDeletePieces(id, status);
      } else {
        this.dialog.closeAll();
      }
    });
  }

  delinkDeletePieces(id, status) {
    this.shipmentService.getPieceList(id).subscribe({
      next: (data: any) => {
        if (data != null) {
          const unLinkPieces = [];
          const unlinkShipments = [];
          unLinkPieces.push(...data.map(shipment => shipment.pieceID));
          unlinkShipments.push(...data.map(shipment => shipment.shipmentID));
          const unique = arr => [...new Set(arr)];
          if (unLinkPieces.length < 1) {
            this.managePallet(status, id);
          } else {
            const reqData = {
              palletID: id,
              pieces: unLinkPieces,
              shipments: unique(unlinkShipments),
              mawb: this.mawId,
            };
            this.mawService.unlinkPieces(reqData).subscribe(() => {
              this.managePallet(status, id);
            });
          }
        }
      },
    });
  }

  onMotherReference(event?: any) {
    const payload = {
      mawbInvoiceReference: this.mawbInvoiceReference || '',
      mawbInvoiceNumber: this.mawbInvoiceNumber || '',
    };

    this.mawService.updatemawbreference(this.mawId, payload).subscribe();
  }

  getPallets() {
    const palletObj: any = {};
    const mawArray = [];
    mawArray[0] = this.mawId;
    palletObj.mawb = mawArray;
    this.mawService.getPalletList(palletObj).subscribe({
      next: data => {
        this.palletsData = data;
        this.ctrycode = data[0].destination_country;
        this.ctryServiceCode = data[0].destination_service_code;
        this.palletList = palletListConvertor(data[0].palletIDList);
        this.dataSource.data = this.palletList;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      // error: error => {
      //   console.error('There was an error!', error);
      // },
    });
  }

  changePackageType(event, palletID) {
    this.palletList.find(item => item?.palletID === palletID).dimensions.length =
      event?.value?.packageLength;
    this.palletList.find(item => item?.palletID === palletID).dimensions.width =
      event?.value?.packageWidth;
    this.palletList.find(item => item?.palletID === palletID).dimensions.height =
      event?.value?.packageHeight;
  }
}
